import i18n from "i18next";
import { z } from "zod";
import { notificationSchema } from "../utils";

const LANG_BASE = "vessel-call.port-services.fields";

export const specialInstructionsOnlySchema = () =>
  z.object({
    specialInstructions: z
      .string()
      .min(
        1,
        i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.special-instructions`),
        }),
      )
      .max(
        1500,
        i18n.t("form-validation.max-length", {
          label: i18n.t(`${LANG_BASE}.special-instructions`),
          required_error: i18n.t("form-validation.required", {
            label: i18n.t(`${LANG_BASE}.special-instructions`),
          }),
          max: 1500,
        }),
      ),
    attachment: z.any().optional(),
    notes: z
      .string()
      .max(
        1000,
        i18n.t("form-validation.max-length", {
          label: i18n.t(`${LANG_BASE}.notes`),
          max: 1000,
        }),
      )
      .optional(),
  });
export const approveByHSESludgeDisposalSchema = () =>
  specialInstructionsOnlySchema().merge(notificationSchema);

export type ApproveByHSESludgeDisposalSchema = z.infer<
  ReturnType<typeof approveByHSESludgeDisposalSchema>
>;
